import { render } from "./comment.html?vue&type=template&id=09f894a6&external"
import script from "./comment.js?vue&type=script&lang=js&external"
export * from "./comment.js?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__